export default "__VITE_ASSET__IOVi3x6h__"